import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileGridDynamic300x250Fs from './freestar/MobileGridDynamic300x250';
import MobileGridDynamic300x250Tab from './taboola/MobileGridDynamic300x250';
const MobileGridDynamic300x250 = ({ safety = 'off', rowId, safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(MobileGridDynamic300x250Tab, {
            rowId: rowId,
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(MobileGridDynamic300x250Fs, {
        safety: safety,
        safetyState: safetyState,
        rowId: rowId
    });
};
MobileGridDynamic300x250.displayName = 'MobileGridDynamic300x250';
export default MobileGridDynamic300x250;
